import styled from "styled-components";

const StyledProjectsPage = styled.section`
  width: 100vw;
  background: linear-gradient(0deg, #6c195a, #1c112b);

  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  position: relative;
  padding-bottom: 50px;
`;

const StyledProjectsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export { StyledProjectsPage, StyledProjectsWrapper };
